import { BackButton } from "@ic-anywhere/ic-components";
import * as React from "react";

export interface Props {
  message: string;
  header?: string;
}

export const ErrorMessage: React.FunctionComponent<Props> = ({ header, message }) => {
  return message ? (
    <div className="w-50 mx-auto mt-5">
      <h1 className="display-3 text-danger">{header || "Something went wrong"}</h1>
      <p className="lead">{`Error detail: ${message}`}</p>
      <div className="ms-1">
        <BackButton />
      </div>
    </div>
  ) : null;
};
